// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jBuU","left":"styles_left__3L5p6","desktopActions":"styles_desktopActions__1Uott","title":"styles_title__X5LUi"};